<ion-icon name="share-social-outline" (click)="share(album, type)"></ion-icon>